export class BlockItemAction{
    protected _text?: string;
    protected _icon?: string;
    protected _type: string;
    protected _value?: any;
    protected _buttonText?: string; // block button text (bottom right btn with icon)

    public constructor(type: string, value: any|undefined, text: string|undefined, icon: string|undefined) {
        this._text = text;
        this._icon = icon;
        this._type = type;
        this._value = value;
    }

    public get text(): string|undefined {
        return this._text;
    }

    public get icon(): string|undefined {
        return this._icon;
    }

    public get value(): any|undefined {
        return this._value;
    }

    public get type(): string {
        return this._type;
    }

    public get buttonText(): string|undefined {
        return this._buttonText;
    }

    public set buttonText(value: string) {
        this._buttonText = value;
    }
}

export interface BlockItemTimer{
    text?: string;
    textColor?: string;
    counter: number
    counterColor?: string;
}

export interface BlockItemContent{
    text?: string,
    color?: string,
    icon?: string
}